

function validateResponse(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export function getOrgAdmin(getUserCallback) {
    console.log('in getOrgAdmin');
    fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/users/currentUser/orgAdmin', {
      headers: {
        'Accept': 'application/json',
        },
        credentials: 'include'
        })
        .then(results=> {
            validateResponse(results);
            return results.json();
        })
        .then(data => {
            console.log('org admin user ' + data);
            getUserCallback(data);
            return data;
        })
        .catch(error => {
            console.log('error trying to fetch org admin user : \n', error);
            return Promise.reject()
        })
  }



// WEBPACK FOOTER //
// ./src/manageMyAccount/GetOrgAdmin.js